import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { AccountBalance as FinanceIcon } from '@mui/icons-material';

interface RefundDashboardHeaderProps {
  company: string;
  center: string;
  totalCount: number;
  totalAmount: number;
}

export const RefundDashboardHeader: React.FC<RefundDashboardHeaderProps> = ({
  company,
  center,
  totalCount,
  totalAmount
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  return (
    <Box sx={{
      backgroundColor: '#ffffff',
      borderBottom: '2px solid #3b82f6',
      p: 1.5
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={2}>
          <FinanceIcon sx={{ color: '#3b82f6', fontSize: 28 }} />
          <Box>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600, 
                color: '#1e293b',
                mb: 0.5
              }}
            >
              Refund Dashboard
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              {company} - {center}
            </Typography>
          </Box>
        </Box>
        
        {/* Summary Statistics */}
        <Stack direction="row" spacing={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
              {totalCount}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b', textTransform: 'uppercase' }}>
              Requests
            </Typography>
          </Box>
          <Divider orientation="vertical" />
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
              {formatCurrency(totalAmount)}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b', textTransform: 'uppercase' }}>
              Total Value
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};